import gql from 'graphql-tag';

export default gql`
    mutation SaveTonnage($input: SaveTonnageInput) {
        saveTonnage(input: $input) {
            errors
        }
    }
`;
